module.exports = __webpack_public_path__ + "img/be.105928e3.jpg";